import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';

import { DeviceDetailsComponent } from './device-detail.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    DeviceDetailsComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatIconModule,
  ],
  exports: [
    DeviceDetailsComponent,
  ],
})
export class DeviceDetailModule { }
